<template>
	<v-container fluid class="px-0" id="listado-planos">
		<!-- Barra de acciones superior -->
		<div class="mb-2 d-flex justify-end" style="gap:10px">
			<v-btn color="#2D4B95" dark small class="m-4" @click="openPlanoTotalViewer">
				<v-icon color="white" small class="mr-1">mdi-eye</v-icon>
				<p class="mb-0 caption text-capitalize">Ver Planos y Entregas</p>
			</v-btn>
			<v-btn color="#2D4B95" dark small class="m-4" @click="$store.entregaStore.commit('setAddPlanoModal', true)">
				<v-icon color="white" small class="mr-1">mdi-note-plus</v-icon>
				<p class="mb-0 caption text-capitalize">Agregar</p>
			</v-btn>
		</div>

		<!-- Diálogo de confirmación para eliminar plano -->
		<v-dialog v-model="confirmDialog" max-width="450">
			<v-card>
				<v-card-title class="headline">Confirmar eliminación</v-card-title>
				<v-card-text>
					¿Está seguro que desea eliminar este plano? Esta acción no se puede deshacer.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" text @click="confirmDialog = false">Cancelar</v-btn>
					<v-btn
						color="red darken-1"
						text
						@click="deletePlano()"
						:loading="deletingPlano"
					>Eliminar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Header de tabla estilo ListadoEntregas -->
		<v-card class="mb-2 py-1">
			<v-card-text class="header-table-card py-2">
				<v-row no-gutters align="center">
					<v-col cols="7">
						<v-btn text class="table-header-button" disabled>
							<p class="font-weight-bold body-2 mb-0">Nombre</p>
						</v-btn>
					</v-col>
					<v-col cols="3">
						<v-btn text class="table-header-button" disabled>
							<p class="font-weight-bold body-2 mb-0">Tipo</p>
						</v-btn>
					</v-col>
					<v-col cols="2">
						<v-btn text class="table-header-button" disabled>
							<p class="font-weight-bold body-2 mb-0">Acciones</p>
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<!-- Lista de planos cargados -->
		<div v-if="planosLoaded">
			<v-card
				class="tarea-card mb-2"
				v-for="(plano, index) in $store.entregaStore.state.planos.data"
				:key="index"
				style="overflow: hidden;"
				@click.stop="hasFile(plano) ? viewPlano(plano.id) : editPlano(plano.id, $event)"
			>
				<v-card-text class="py-2 px-4">
					<v-row no-gutters align="center">
						<!-- Nombre + ícono de tipo -->
						<v-col cols="7" class="d-flex align-center">
							<v-icon
								:color="!hasFile(plano) ? 'grey' : isForge(plano) ? '#5e85ef' : '#4CAF50'"
								class="mr-2"
								small
							>
								{{ !hasFile(plano) ? 'mdi-file-off-outline' : isForge(plano) ? 'mdi-cube-scan' : 'mdi-image' }}
							</v-icon>
							<span class="body-2 font-weight-medium">{{ plano.title }}</span>
						</v-col>

							<!-- Chip de tipo -->
						<v-col cols="3">
							<v-chip
								small
								:color="!hasFile(plano) ? 'grey lighten-1' : isForge(plano) ? '#5e85ef' : '#4CAF50'"
								text-color="white"
								class="font-weight-bold"
							>
								{{ !hasFile(plano) ? 'Sin Archivo' : isForge(plano) ? 'Visor Autodesk' : 'Imagen' }}
							</v-chip>
						</v-col>

						<!-- Botones de acción -->
						<v-col cols="2" class="d-flex justify-end">
							<v-btn
								icon
								small
								color="#5e85ef"
								class="mr-1"
								@click.stop="editPlano(plano.id, $event)"
							>
								<v-icon small>mdi-pencil</v-icon>
							</v-btn>
							<v-btn
								icon
								small
								color="#F4516C"
								@click.stop="confirmDeletePlano(plano.id, $event)"
							>
								<v-icon small>mdi-delete</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

			<!-- Sin planos -->
			<v-card v-if="!$store.entregaStore.state.planos.data || $store.entregaStore.state.planos.data.length === 0" class="mb-2">
				<v-card-text class="text-center grey--text py-8">
					<v-icon large color="grey lighten-1">mdi-image-off-outline</v-icon>
					<p class="mt-2 mb-0">No hay planos registrados</p>
				</v-card-text>
			</v-card>
		</div>

		<!-- Skeletons de carga -->
		<div v-else>
			<v-card class="mb-2" v-for="n in 5" :key="'sk-' + n">
				<v-card-text class="py-2 px-4">
					<v-row no-gutters align="center">
						<v-col cols="7">
							<v-skeleton-loader type="text" width="60%"></v-skeleton-loader>
						</v-col>
						<v-col cols="3">
							<v-skeleton-loader type="chip" width="80px"></v-skeleton-loader>
						</v-col>
						<v-col cols="2" class="d-flex justify-end">
							<v-skeleton-loader type="avatar" class="mr-1"></v-skeleton-loader>
							<v-skeleton-loader type="avatar"></v-skeleton-loader>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</div>

		<!-- Paginación -->
		<v-row align="center">
			<v-col cols="12">
				<v-pagination
					v-model="page"
					color="#2D4B95"
					:length="Math.ceil(($store.entregaStore.state.planos.total || 0) / 50)"
					:total-visible="7"
					@input="changePlanoPage"
				></v-pagination>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
import { deletePlano, getPlano } from '@/helpers/api/entrega';

export default {
	name: 'Planos',
	data: () => ({
		page: 1,
		confirmDialog: false,
		deletingPlano: false,
		selectedPlanoId: null
	}),
	computed: {
		selectedProject(){
			return this.$store.projectsStore.state.selectedProject
		},
		planosLoaded() {
			return this.$store.entregaStore.state.planos.status !== 99;
		}
	},
	watch: {
		selectedProject(newVal, oldVal){
			if(newVal?.id === oldVal?.id) return
			this.page = 1
			this.selectedPlanoId = null
			if(newVal?.id) this.loadPlanos()
		}
	},
	mounted() {
		this.loadPlanos();
	},
	methods: {
		hasFile(plano) {
			return !!(plano.file);
		},
		isForge(plano) {
			return !!(plano.file && plano.file.forge_file && plano.file.forge_file.urn);
		},
		loadPlanos() {
			if (!this.$store.entregaStore.state.planos.data || this.$store.entregaStore.state.planos.data.length === 0) {
				this.$store.entregaStore.dispatch('getPlanos', {
					project_id: this.$store.projectsStore.state.selectedProject.id,
					page: this.page
				});
			}
		},
		changePlanoPage(page) {
			this.page = page;
			this.$store.entregaStore.dispatch('getPlanos', {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				page: page
			});
		},
		viewPlano(planoId) {
			this.$store.entregaStore.commit('setPlanoTotalViewerPlanoId', planoId);
			this.$store.entregaStore.commit('setPlanoTotalViewerModal', true);
		},
		editPlano(planoId, event) {
			if (event) event.stopPropagation();
			this.$store.entregaStore.commit('setSelectedPlanoId', planoId);
			this.$store.entregaStore.commit('setEditPlanoModal', true);
		},
		openPlanoTotalViewer() {
			this.loadPlanos();
			this.$store.entregaStore.commit('setPlanoTotalViewerPlanoId', null);
			this.$store.entregaStore.commit('setPlanoTotalViewerModal', true);
		},
		confirmDeletePlano(planoId, event) {
			if (event) event.stopPropagation();
			this.selectedPlanoId = planoId;
			this.confirmDialog = true;
		},
		async deletePlano() {
			if (!this.selectedPlanoId) return;

			try {
				this.deletingPlano = true;
				const projectId = this.$store.projectsStore.state.selectedProject.id;

				const planoResponse = await getPlano({
					project_id: projectId,
					plano_id: this.selectedPlanoId
				});

				if (planoResponse.code === 200) {
					if (planoResponse.planos && planoResponse.planos.length > 0) {
						this.showMessage({ message: 'El plano tiene emplazamientos activos, no se puede eliminar', title: 'Error', type: 'error' });
						this.confirmDialog = false;
						return;
					}

					const deleteResponse = await deletePlano({
						project_id: projectId,
						plano_id: this.selectedPlanoId
					});

					if (deleteResponse.code === 200) {
						this.showMessage({ message: 'Plano eliminado correctamente', title: 'Éxito', type: 'success' });
						this.$store.entregaStore.dispatch('getPlanos', { project_id: projectId, page: this.page });
					} else {
						this.showMessage({ message: deleteResponse.message || 'Error al eliminar el plano', title: 'Error', type: 'error' });
					}
				} else {
					this.showMessage({ message: planoResponse.message || 'Error al obtener información del plano', title: 'Error', type: 'error' });
				}
			} catch (error) {
				console.error('Error al eliminar plano:', error);
				this.showMessage({ message: 'Error al eliminar el plano', title: 'Error', type: 'error' });
			} finally {
				this.deletingPlano = false;
				this.confirmDialog = false;
			}
		},
		showMessage(data) {
			this.$store.globalStore.dispatch('addMessage', {
				message: data.message,
				title: data.title || 'Notificación',
				created: new Date(),
				type: data.type || 'info',
				icon: data.type === 'error' ? 'mdi-alert-circle' : 'mdi-check-circle',
				color: data.type === 'error' ? '#fb8c00' : '#4CAF50'
			});
		}
	}
};
</script>

<style scoped>
.light-blue-text { color: #5E85EF; }
.tarea-card {
	position: relative;
	transition: transform 0.2s, box-shadow 0.2s;
	cursor: pointer;
}
.tarea-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.header-table-card {
	border: 1px solid white;
}
.table-header-button {
	text-transform: none;
}
</style>